import { Component, OnInit } from '@angular/core';
import { CardComponent } from '@microsec/components';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { DOMAIN } from '@microsec/constants';

@Component({
  selector: 'app-personal-information',
  templateUrl: './personal-information.component.html',
  styleUrls: ['./personal-information.component.scss'],
  imports: [DividerModule, ButtonModule, CardComponent],
})
export class PersonalInformationComponent implements OnInit {
  isLoading = true;

  ngOnInit() {
    this.isLoading = false;
  }

  openLink() {
    window.open(`https://${localStorage.getItem(DOMAIN)}/auth/realms/microsec/account/`, '_blank');
  }
}
